import { httpGet, httpPost, httpDelete, httpPut } from "../Util/http";
import { addAlert } from "../MsgNotify/msgNotifyActions";

export const SET_REDUCER_STATE = "SET_REDUCER_STATE";
export const setState = (key, val) => {
  return {
    type: SET_REDUCER_STATE,
    key: key,
    val: val,
  };
};

export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const getProductsRequest = () => {
  return {
    type: GET_PRODUCTS_REQUEST,
  };
};

export const GET_PRODUCTS_REQUEST_SUCCESS = "GET_PRODUCTS_REQUEST_SUCCESS";
export const getProductsRequestSuccess = (products) => {
  return {
    type: GET_PRODUCTS_REQUEST_SUCCESS,
    products,
  };
};

export const GET_PRODUCTS_REQUEST_FAILLURE = "GET_PRODUCTS_REQUEST_FAILLURE";
export const getProductsRequestFailure = () => {
  return {
    type: GET_PRODUCTS_REQUEST_FAILLURE,
  };
};

export const fetchProducts = (skip, take) => {
  const url =
    process.env.REACT_APP_productCatalogEndPoint +
    `api/product?skip=${skip}&take=${take}`;
  return (dispatch) => {
    dispatch(getProductsRequest());
    return httpGet(url)
      .then((response) => response.json())
      .then((products) => dispatch(getProductsRequestSuccess(products)))
      .catch(() => {
        dispatch(getProductsRequestFailure());
        dispatch(addAlert("kunne ikke hente data, prøv at genindlæse siden"));
      });
  };
};

export const CREATE_PRODUCT_REQUEST = "CREATE_PRODUCT_REQUEST";
export const createProductRequest = () => {
  return {
    type: CREATE_PRODUCT_REQUEST,
  };
};

export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS";
export const createProductSuccess = (id, product) => {
  return {
    type: CREATE_PRODUCT_SUCCESS,
    product: { ...product, productId: id },
  };
};

export const CREATE_PRODUCT_REQUEST_FAILURE = "CREATE_PRODUCT_REQUEST_FAILURE";
export const createProductRequestFailure = () => {
  return {
    type: CREATE_PRODUCT_REQUEST_FAILURE,
  };
};

export const createProduct = (createProduct) => {
  const url = process.env.REACT_APP_productCatalogEndPoint + "api/product";
  return (dispatch) => {
    dispatch(createProductRequest());
    return httpPost(url, createProduct)
      .then((response) => response.json())
      .then((id) => {
        if (!createProduct.dataSheet) {
          createProduct.dataSheetUrl = "none";
        } else {
          createProduct.dataSheetUrl = createProduct.dataSheet;
        }
        if (!createProduct.technicalDataSheet) {
          createProduct.technicalDataSheetUrl = "none";
        } else {
          createProduct.technicalDataSheetUrl =
            createProduct.technicalDataSheet;
        }
        if (!createProduct.chemDataSheet) {
          createProduct.chemDataSheetUrl = "none";
        } else {
          createProduct.chemDataSheetUrl = createProduct.chemDataSheet;
        }
        dispatch(createProductSuccess(id, createProduct));
      })
      .catch((error) => {
        dispatch(createProductRequestFailure());
        dispatch(addAlert(error.message));
      });
  };
};

export const EDIT_PRODUCT_REQUEST = "EDIT_PRODUCT_REQUEST";
export const editProductRequest = () => {
  return {
    type: EDIT_PRODUCT_REQUEST,
  };
};

export const EDIT_PRODUCT_SUCCESS = "EDIT_PRODUCT_SUCCESS";
export const editProductSuccess = (editedProduct, index) => {
  return {
    type: EDIT_PRODUCT_SUCCESS,
    product: editedProduct,
    index: index,
  };
};

export const EDIT_PRODUCT_REQUEST_FAILURE = "EDIT_PRODUCT_REQUEST_FAILURE";
export const editProductRequestFailure = () => {
  return {
    type: EDIT_PRODUCT_REQUEST_FAILURE,
  };
};

export const editProduct = (editedProduct, index) => {
  const url = process.env.REACT_APP_productCatalogEndPoint + `api/product/`;
  return (dispatch) => {
    dispatch(editProductRequest());
    return httpPut(url, {
      productId: editedProduct.productId,
      name: editedProduct.name,
      type: editedProduct.type,
      price: editedProduct.price,
      unit: editedProduct.unit,
      deletable: editedProduct.deletable,
      dataSheet: editedProduct.dataSheet,
      technicalDataSheet: editedProduct.technicalDataSheet,
      chemDataSheet: editedProduct.chemDataSheet,
    })
      .then((response) => response.status)
      .then(() => {
        if (editedProduct.dataSheet === "delete") {
          editedProduct.dataSheetUrl = "none";
        } else {
          editedProduct.dataSheetUrl = editedProduct.dataSheet;
        }
        if (editedProduct.technicalDataSheet === "delete") {
          editedProduct.technicalDataSheetUrl = "none";
        } else {
          editedProduct.technicalDataSheetUrl = editedProduct.technicalDataSheet;
        }
        if (editedProduct.chemDataSheet === "delete") {
          editedProduct.chemDataSheetUrl = "none";
        } else {
          editedProduct.chemDataSheetUrl = editedProduct.chemDataSheet;
        }
        dispatch(editProductSuccess(editedProduct, index));
      })
      .catch((error) => {
        dispatch(editProductRequestFailure());
        dispatch(addAlert(error.message));
      });
  };
};

export const SEARCH_PRODUCTS_REQUEST_SUCCESS =
  "SEARCH_PRODUCTS_REQUEST_SUCCESS";
export const searchProductsRequestSuccess = (products) => {
  return {
    type: SEARCH_PRODUCTS_REQUEST_SUCCESS,
    products,
  };
};

export const SEARCH_PRODUCTS_REQUEST = "SEARCH_PRODUCTS_REQUEST";
export const searchProductRequest = () => {
  return {
    type: SEARCH_PRODUCTS_REQUEST,
  };
};

export const SEARCH_PRODUCTS_REQUEST_FAILURE =
  "SEARCH_PRODUCTS_REQUEST_FAILURE";
export const searchProductRequestFailure = () => {
  return {
    type: SEARCH_PRODUCTS_REQUEST_FAILURE,
  };
};

export const searchProduct = (query, skip, take) => {
  const url =
    process.env.REACT_APP_productCatalogEndPoint +
    `api/product/search?search=${query}&skip=${skip}&take=${take}`;
  return (dispatch) => {
    dispatch(searchProductRequest());
    return httpGet(url)
      .then((response) => response.json())
      .then((json) => dispatch(searchProductsRequestSuccess(json)))
      .catch(() => {
        dispatch(getProductsRequestFailure());
        dispatch(addAlert("kunne ikke hente data, prøv at genindlæse siden"));
      });
  };
};

export const searchProductPaginate = (query, skip, take) => {
  const url =
    process.env.REACT_APP_productCatalogEndPoint +
    `api/product/search?search=${query}&skip=${skip}&take=${take}`;
  return (dispatch) => {
    dispatch(searchProductRequest());
    return httpGet(url)
      .then((response) => response.json())
      .then((json) => dispatch(getProductsRequestSuccess(json)))
      .catch(() => {
        dispatch(getProductsRequestFailure());
        dispatch(addAlert("kunne ikke hente data, prøv at genindlæse siden"));
      });
  };
};

export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST";
export const deleteProductRequest = () => {
  return {
    type: DELETE_PRODUCT_REQUEST,
  };
};

export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const deleteProductSuccess = (index) => {
  return {
    type: DELETE_PRODUCT_SUCCESS,
    index: index,
  };
};

export const DELETE_PRODUCT_REQUEST_FAILURE = "DELETE_PRODUCT_REQUEST_FAILURE";
export const deleteProductRequestFailure = () => {
  return {
    type: DELETE_PRODUCT_REQUEST_FAILURE,
  };
};

export const deleteProduct = (id, index) => {
  const url =
    process.env.REACT_APP_productCatalogEndPoint + `api/product/${id}`;
  return (dispatch) => {
    dispatch(deleteProductRequest());
    return httpDelete(url)
      .then((response) => response.status)
      .then(() => dispatch(deleteProductSuccess(index)))
      .catch(() => {
        dispatch(deleteProductRequestFailure());
        dispatch(addAlert("kunne ikke slette den, prøv igen"));
      });
  };
};



// WEBPACK FOOTER //
// ./src/App/Product/actions.js